import {useContext} from 'react'

import {toQueryString} from '@s-ui/js/lib/string'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'
import ArrowRight from '@adv-mt/mt-svg-icons/lib/ArrowRight'
import Feedback from '@adv-mt/mt-svg-icons/lib/FeedbackOutline'

import LinkFactory from '../../../../components/LinkFactory/index.js'

const InfoArea = () => {
  const {user} = useContext(AuthenticationContext)
  const {browser} = useContext(Context)

  const urlParams = toQueryString({
    user_id: user?.userId,
    useragent: browser?.browserName,
    device: browser?.deviceType,
    platform: browser?.osName
  })
  const urlToRedirect = `https://form.typeform.com/to/XFDWZ7Za#${urlParams}`

  return (
    <LinkFactory className="mt-UserMessages-infoArea" href={urlToRedirect} target="_blank">
      <div className="mt-UserMessages-infoAreaContent">
        <div className="mt-UserMessages-infoAreaPhoneIcon" size={ATOM_ICON_SIZES.medium}>
          <Feedback />
        </div>
        <p>¿Qué te parece el nuevo chat? Tu opinión nos ayuda a mejorarlo</p>
      </div>
      <AtomIcon size={ATOM_ICON_SIZES.medium}>
        <ArrowRight />
      </AtomIcon>
    </LinkFactory>
  )
}

export default InfoArea
